import { Grid, Slider } from '@material-ui/core'
import { makeStyles, Theme } from '@material-ui/core/styles'
import { theme } from 'config/constants/theme/theme'
import { withStyles } from '@material-ui/styles'

export const RatingSlider = withStyles({
  root: {
    color: '#F26723',
    backgroundColor: '#C3C3C3',
    height: 6,
    padding: 0,
    margin: '.2rem 0',
    borderRadius: 4,
    '&.Mui-disabled': {
      color: '#F26723',
      backgroundColor: '#C3C3C3',
      height: 6
    },
    [theme.breakpoints.down('md')]: {
      height: 8
    }
  },
  thumb: {
    height: 12,
    width: 12,
    backgroundColor: '#369adc',
    marginTop: -3,
    marginLeft: -5,
    '&:focus,&:hover,&$active': {
      boxShadow: 'inherit'
    },
    '&.Mui-disabled': {
      visibility: 'hidden'
    }
  },
  active: {},
  valueLabel: {
    left: 'calc(-50% + 4px)'
  },
  track: {
    height: 6,
    borderRadius: 4
  },
  rail: {
    height: 6,
    backgroundColor: '#C3C3C3',
    borderRadius: 4
  },
  mark: {
    backgroundColor: '#979797',
    height: 6,
    [theme.breakpoints.down('md')]: {
      height: 8
    }
  }
})(Slider)

export const Container = withStyles({
  root: {
    minHeight: '168px',
    [theme.breakpoints.down('md')]: {
      padding: 0
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: '110px'
    }
  }
})(Grid)

export default makeStyles<Theme>(theme => ({
  firstContainer: {
    width: '100%'
  },
  becomeExpertIn: {
    height: '38px',
    width: '417px',
    color: '#225190',
    fontSize: '38px',
    fontWeight: 300,
    lineHeight: '38px',
    [theme.breakpoints.down('sm')]: {
      fontSize: 24
    }
  },
  title: {
    color: '#225190',
    fontSize: 18,
    fontWeight: 500,
    letterSpacing: '0.04em'
  },
  headerKnowledge: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    margin: '0 0 1rem 0',
    [theme.breakpoints.down('sm')]: {
      margin: '1rem 0 1rem 0'
    }
  },
  balloon: {
    marginTop: '5px',
    [theme.breakpoints.down('sm')]: {
      marginTop: '1.2rem'
    }
  },
  ratingContainer: {
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0
    }
  },
  gridContainer: {
    [theme.breakpoints.down('md')]: {
      padding: '5px 15px 10px'
    }
  },
  knowledgeTitle: {
    fontSize: '28px',
    color: '#7647b2',
    [theme.breakpoints.down('sm')]: {
      fontSize: '20px',
      fontWeight: 300
    }
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '.2rem'
  },
  paragraph: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  definedCategory: {
    fontSize: '15px'
  },
  gridExpertise: {
    paddingTop: '0 !important'
  },
  expertise: {
    fontSize: '12px',
    width: 113,
    color: '#6C6471'
  },
  marksEmpty: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  marksLevelThree: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'block',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  marksFull: {
    '& :nth-child(4)': {
      display: 'none'
    },
    '& :nth-child(6)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(8)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(10)': {
      display: 'none',
      width: '1px'
    },
    '& :nth-child(12)': {
      display: 'none'
    }
  },
  becomeExpertInContainer: {},
  learning: {
    color: '#1C9CDE',
    fontSize: '18px',
    paddingTop: '.2rem',
    display: 'flex',
    flex: 1,
    borderRadius: '.2rem'
  },
  becomeExpertInRootContainer: {
    marginTop: '50px',
    marginBottom: '-30px'
  },
  becomeExpertInItem: {
    display: 'flex',
    justifyContent: 'flex-start',
    whiteSpace: 'nowrap'
  },
  becomeExpertInValue: {
    display: 'flex',
    flex: 1,
    justifyContent: 'flex-start',
    flexDirection: 'column',
    marginTop: 5
  },
  divider: {
    backgroundColor: 'rgba(65, 50, 146, 0.75)',
    marginTop: 5,
    width: 'calc(100% - 60px)',
    [theme.breakpoints.down('sm')]: {
      width: '100%'
    }
  }
}))
